
import { Component, Inject, OnInit, DOCUMENT } from '@angular/core';

@Component({
    selector: 'app-logout',
    templateUrl: './logout.component.html',
    styleUrls: ['./logout.component.scss'],
    standalone: false
})
export class LogoutComponent implements OnInit {

  constructor( @Inject(DOCUMENT) private document: Document,) { }

  ngOnInit(): void {
    //alert("dd")
    //https://login.microsoftonline.com/55ab44f3-be48-4bbb-bb8d-a860780fd8a8/oauth2/v2.0/logout?post_logout_redirect_uri=https://dcn-esign-np-gateway-dev.apps.pvtgfpte.ngco.com/
    this.document.location.href  = "https://login.microsoftonline.com/55ab44f3-be48-4bbb-bb8d-a860780fd8a8/oauth2/v2.0/logout"
    //?post_logout_redirect_uri=https://dcn-esign-np-gateway-uat.apps.pvtgfpte.ngco.com/";
  }

}
